<template>
    <v-expansion-panel class="mb-2 base-panel" :alvqa="alvqa">
        <v-expansion-panel-header 
            @click="functionsOnClickEvent"
            color="panelHeaderBackground"
        >
            <div class="d-flex align-center full-width">
                <div v-if="helpContext" class="mr-2" @click.stop>
                    <ContextHelpIcon 
                        :context="helpContext"
                        :section="helpSection"
                        :panelTitle="$alvPlugin.isLangConst(headline) ? $t(headline) : headline"
                        :alvqa="alvqa + '-context-help-icon'"
                    />
                </div>
                <div :alvqa="alvqa + '-title'">
                    {{ $alvPlugin.isLangConst(headline) ? $t(headline) : headline }}
                </div>
            </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content color="panelContentBackground">
            <v-container fluid><slot name="panelContent"></slot></v-container>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<style scoped>
.full-width {
    width: 100%;
}
/* Force BasePanel headers to identical height - only affects BasePanel components */
.base-panel .v-expansion-panel-header {
    min-height: 56px !important;
    max-height: 56px !important;
}
</style>

<script>
import ContextHelpIcon from '@/components/_buttons/ContextHelpIcon.vue'

export default {
    name: "BasePanel",
    props: {
        headline: String,
        alvqa: {
            type: String,
            default: ''
        },
        onOpenPanel: {
            type: Function,
            default: () => {}
        },
        helpContext: {
            type: String,
            default: null
        },
        helpSection: {
            type: String,
            default: null
        }
    },
    methods:{
    /**
     * Emiter for ERP => Shipping => Edit to send 
     * information that shipping panel was opened
     */
        onExpandPanel(){
            this.$emit('clickOnPanel')
        },
        
        functionsOnClickEvent(){

            //ERP => Shipping => Edit
            this.onExpandPanel()

            //Method passed from Components to BasePanel as prop
            this.onOpenPanel()
        }
    },
    components: {
        ContextHelpIcon
    }

}
</script>